var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['page', {}],attrs:{"id":"home"}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.loaded)?_c('div',{staticClass:"page wrapper"},[_c('the-header'),_c('router-view')],1):_c('splash')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }